<div class="page-container gap-3">
  <a
    routerLink="/forms"
    aria-label="Back to forms"
    class="inline-flex size-8 shrink-0 items-center justify-center rounded-lg border border-slate-200 bg-white text-slate-800 transition hover:bg-slate-50">
    <app-svg-icon src="assets/icons/arrow-left.svg" [size]="16" />
  </a>

  <section class="page-fill rounded-2xl border border-neutral-200 bg-white">
    <app-signal-data-table
      class="page-fill-host"
      [columnDefs]="columnDefs()"
      [state]="tableState"
      [pageSize]="200"
      [enableSearch]="false"
      [enableHorizontallyScrollable]="true"
      (tableStateChanged)="onTableStateChanged($event)" />
  </section>
</div>
